import { render, staticRenderFns } from "./AddCertificates.vue?vue&type=template&id=668f7eb9&scoped=true"
import script from "./AddCertificates.vue?vue&type=script&lang=js"
export * from "./AddCertificates.vue?vue&type=script&lang=js"
import style0 from "./AddCertificates.vue?vue&type=style&index=0&id=668f7eb9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668f7eb9",
  null
  
)

export default component.exports